import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthRedirectGuard } from './core/guards/auth-redirect.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'pecs',
        loadChildren: () =>
          import('./features/prise-charge/pec.module').then(
            (m) => m.PecModule
          ),
      },
      {
        path: 'reglement',
        loadChildren: () =>
          import('./features/bordereau-paiement/bdrpmt.module').then(
            (m) => m.BdrpmtModule
          ),
      },
      {
        path: 'verfication-adherent',
        loadChildren: () =>
          import('./features/verfication-adherent/verfication-adherent.module').then(
            (m) => m.VerficationAdherentModule
          ),
      },
      {
        path: 'reclamations',
        loadChildren: () => import('./features/reclamations/reclamations.module')
          .then(m => m.ReclamationsModule)
      },
      {
        path: 'mon-compte',
        loadChildren: () => import('./features/mon-compte/mon-compte.module')
          .then(m => m.MonCompteModule)
      },
      {
        path: 'mes-demandes',
        loadChildren: () => import('./features/mes-demandes/mes-demandes.module')
          .then(m => m.MesDemandesModule)
      }
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [AuthRedirectGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }